import UserList from './UserList';
import UserEdit from './UserEdit';
import UserCreate from './UserCreate';
import { UserIcon } from '../../core/themes/icons/UserIcon';

export default {
  list: UserList,
  create: UserCreate,
  edit: UserEdit,
  icon: UserIcon
};
